import { Typography } from '@hulu/react-style-components';
import { type FC } from 'react';

import { ReactComponent as WarningIcon } from '../../assets/images/warning.svg';
import { StyledTitle, StyledWarningNotification } from './styled';

type Props = {
  title: string;
  description: string;
  testId?: string;
};

const WarningNotification: FC<Props> = ({ description, title, testId = 'warningNotificationWrapper' }): JSX.Element => (
  <StyledWarningNotification data-testid={testId}>
    <WarningIcon />
    <StyledTitle variant="body1" data-testid="warningNotificationTitle">
      {title}
    </StyledTitle>
    <Typography variant="body1" data-testid="warningNotificationDescription">
      {description}
    </Typography>
  </StyledWarningNotification>
);

export default WarningNotification;
